import { Modal } from "antd";
import cn from "classnames";
import "./custom.css";
import { useEffect } from "react";
import { useDisableScroll } from "~/hooks/useDisableScroll";

type Props = {
  isModalOpen: boolean;
  onOkModal: () => void | Promise<void>;
  onCancelModal: () => void;
  title?: string;
  description?: string;
  okButtonText?: string;
  cancelButtonText?: string;
  customStyleProps?: React.CSSProperties;
  customClassName?: string;
};

export const AlertModal = (props: Props) => {
  const { disableScroll, enableScroll } = useDisableScroll();

  useEffect(() => {
    if (props.isModalOpen) {
      disableScroll();
    } else {
      enableScroll();
    }
  }, [props.isModalOpen]);

  return (
    <Modal
      closeIcon={null}
      centered
      getContainer={false}
      title={props.title ?? "Default Alert Modal Title"}
      open={props.isModalOpen}
      onOk={props.onOkModal}
      onCancel={props.onCancelModal}
      okText={props.okButtonText ?? "Okay"}
      cancelText={props.cancelButtonText ?? "Cancel"}
      style={{ ...props.customStyleProps, textAlign: "center" }}
      className={cn("alert-modal !w-[300px]", props.customClassName)}
      cancelButtonProps={{
        style: {
          width: "45%",
          backgroundColor: "#00000040",
          border: "none",
          color: "#fff",
        },
      }}
      okButtonProps={{ style: { width: "45%", backgroundColor: "#2f54eb" } }}
    >
      {props.description ? props.description : undefined}
    </Modal>
  );
};
